module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-left-0ed0c5ee.svg";